(() => {
  const container = document.querySelector('[data-aistone-website-hours]');
  if (!container || container.dataset.aistoneWebsiteHoursBound === 'true') return;
  container.dataset.aistoneWebsiteHoursBound = 'true';
  const endpoint = ['localhost', '127.0.0.1'].includes(window.location.hostname)
    ? 'http://localhost:3100/api/public/hours/website'
    : 'https://admin.aistone.com/api/public/hours/website';

  fetch(endpoint, {
    cache: 'no-store',
    headers: { Accept: 'text/html' }
  })
    .then((response) => {
      if (!response.ok) throw new Error(`Website hours request failed: ${response.status}`);
      return response.text();
    })
    .then((html) => {
      const documentFragment = new DOMParser().parseFromString(html, 'text/html');
      const responseRoot = documentFragment.querySelector('.aistone-website-hours');
      if (!responseRoot) throw new Error('Website hours response is missing its root element');

      const existingChildren = Array.from(container.children);
      const warehouseIndex = existingChildren.findIndex((element) => element.textContent?.includes('Visit our warehouse'));
      const storeIndex = existingChildren.findIndex((element, index) => (
        index > warehouseIndex && element.textContent?.includes('Visit our store')
      ));
      const callIndex = existingChildren.findIndex((element, index) => (
        index > storeIndex && element.textContent?.trim().startsWith('Call ')
      ));
      if (
        warehouseIndex < 0
        || storeIndex <= warehouseIndex + 1
        || storeIndex + 1 >= callIndex
      ) {
        throw new Error('Website hours fallback block was not found');
      }

      const insertionPoint = existingChildren[warehouseIndex];
      const fallbackHoursParagraphs = [
        existingChildren[warehouseIndex],
        existingChildren[warehouseIndex + 1],
        existingChildren[storeIndex],
        existingChildren[storeIndex + 1]
      ];
      const replacementParagraphs = Array.from(responseRoot.children).filter((element) => (
        element.classList.contains('aistone-website-hours__paragraph')
      ));
      if (!replacementParagraphs.length) throw new Error('Website hours response is empty');

      replacementParagraphs.forEach((paragraph) => {
        container.insertBefore(document.importNode(paragraph, true), insertionPoint);
      });
      fallbackHoursParagraphs.forEach((paragraph) => paragraph.remove());
      container.dataset.hoursContentRevision = responseRoot.dataset.contentRevision || '';
      container.dataset.hoursSource = responseRoot.dataset.source || '';
      container.dataset.hoursDate = responseRoot.dataset.date || '';
    })
    .catch(() => {
      // Keep the configured Shopify footer text visible as the fallback.
    });
})();
